import { fetchFinance } from "utils/api";

export const queryList = async (params) => {
  return await fetchFinance("/sales/activity", {
    type: "trans",
    ...params,
  });
};

export const exportCsv = async (params) => {
  return await fetchFinance("/sales/activity", {
    type: "trans",
    output: "csv",
    ...params,
  });
};

export const querySales = async (params) => {
  return await fetchFinance("/action", {
    action: "getSales",
    ...params,
  });
};

export const queryReferrer = async (params) => {
  return await fetchFinance("/action", {
    action: "getReferrer",
    ...params,
  });
};
